import React from 'react';
import { Link } from 'react-router-dom';

const BookCard = ({ book, toggleFavorite }) => {
  return (
    <div className="book-card">

      <Link to={`/book/${book.name}`}>
        <button style={{height: '40px', width: '180px'}} >Читать</button></Link>
        <button style={{marginLeft:'20px',height: '40px', width: '50px'}}
          onClick={() => toggleFavorite(book.name)}
          className={book.isFavorite ? 'favorite' : ''}
        >
          {book.isFavorite ? '❤️' : '♡'}
        </button>
      <br/> <br/>

      <h3>{book.title}</h3>
      <p className="author">{book.author}</p>
      <p className="category">{book.category}</p>

    </div>
  );
};

export default BookCard;